export * from './src/bookings-v2-attendance-attendance.meta.js';
